import docIcon from "../../assets/img/docIcon02.svg";
import Cancelimg from "../../assets/img/cancel-01.svg";
import useTranslator from "../../hooks/useTranslator";
const ApprovedModal = ({
  showPopup,
  setShowApprovalPopup,
  onhandleManualUpload,
  availableClaveDocs,
  handleInitiateClave,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen">
          <div className="popup-content2 popup-content bg-white saveTimePopup w-50">
            <div className="row">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-between heading-section">
                <div>
                  <h4>{_t("saveTimeGetApprovedFaster")}</h4>
                </div>
                <div>
                  <img
                    src={Cancelimg}
                    alt="icon"
                    className="canceicon"
                    onClick={onhandleManualUpload}
                  />
                </div>
              </div>
              {availableClaveDocs.map((name) => (
                <div className="row">
                  <div className="col-md-6">
                    <div className="annual-report d-flex align-items-center gap-2">
                      <img className="docoment-img2" src={docIcon} alt="icon" />
                      <div>
                        <p className="staticdata_div">
                          {_t(name, "", "fixed")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <p className="fw-medium staticdata_div subtitleApprovedModal">
                {_t(
                  "landlordsPreferToGetTenantDocumentsViaClavepinItHelpsLandlordsToTrustYourProfileAndMakeYourProfileStrongerAmongstOthers"
                )}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 custom-mt-4">
              <button
                type="button"
                className="btnNext btnnextpre w-100"
                onClick={onhandleManualUpload}
              >
                {_t("keepUploadingManually")}
              </button>
              <button
                type="button"
                className="btnNext w-100 greenHover"
                onClick={(e) => {
                  handleInitiateClave();
                  setShowApprovalPopup(false);
                }}
              >
                {_t("getFromClavepin")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApprovedModal;
